import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import {
  clearDeployReloadFlag,
  isStaleDeployError,
  reloadForNewDeploy,
} from "./utils/reloadForNewDeploy";

// Successful boot after a deploy-reload - allow a future auto-reload.
clearDeployReloadFlag();

window.addEventListener("unhandledrejection", (event) => {
  if (isStaleDeployError(event.reason)) {
    event.preventDefault();
    reloadForNewDeploy();
  }
});

const app = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
ReactDOM.render(app, document.getElementById("root"));
serviceWorker.unregister();
